
import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";

let _msg_notsaved = "";


export function initialize(notsaved: string): void {
    _msg_notsaved = notsaved;

    $("#availableSearchBox").on("input", function () {
        const searchString = $(this).val().toString();
        const listBox = $("#NotSelected").data("kendoListBox");
        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });

    $("#selectedSearchBox").on("input", function () {
        const searchString = $(this).val().toString();
        const listBox = $("#Selected").data("kendoListBox");
        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });
}

export function getDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

export function createPagers(actionUrl: string): void {
    const newPagers = $("#NewPagers").data("kendoTextArea").value();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { serialNumbers: newPagers },
        success: function (response: responseModel | undefined | null) {
            // Clear newpagers textarea
            $("#NewPagers").data("kendoTextArea").value("");
            $("#NewPagers").trigger("input"); // do an empty input so the 'precom-dirtyInput' class gets removed

            // Update NotSelected pagers listBox
            $("#NotSelected").data("kendoListBox").dataSource.read();

            if (!response.Succesfully) {
                if (response.Message)
                    dialog.createWarningDialog(response.State == -409 ? "Pager already exists" : "Message", response.Message);
                else
                    dialog.createWarningDialog("Error", "");
                return;
            }
        }
    });
}

export function deletePagers(actionUrl: string): void {
    const pagersStr: string[] = [];

    const listBoxFrom = $("#NotSelected").data("kendoListBox");
    const selectedItems = listBoxFrom.select();

    for (let i = 0; i < selectedItems.length; i++) {
        const index = listBoxFrom.items().index(selectedItems[i]);
        const item = listBoxFrom.dataSource.view()[index];

        if (!item.Disabled) {
            pagersStr.push(item.Value);
            listBoxFrom.remove(selectedItems[i]);
        }
    }

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { selectedPagers: pagersStr },
        success: function () {
            // listBoxFrom.remove(selectedItems[i]);           // Fout, i is onbekend
            listBoxFrom.refresh();
        }
    });
}

export function movePagers(actionUrl: string): void {
    const pagers = $("#Selected").data("kendoListBox").dataSource.data();
    const pagersStr: string[] = [];
    const selectedNodeId = $("#NodeID").data("kendoDropDownList").value();

    pagers.forEach((item: SelectListItem) => {
        pagersStr.push(item.Value);
    });

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { selectedPagers: pagersStr, nodeID: selectedNodeId },
        success: function () {
            $("#Selected").data("kendoListBox").dataSource.read();
        }
    });
}

export function setNumberSelected(): void {
    setTimeout(() => { // setTimeout to make sure the values are read after the listboxes are updated
        if ($("#Selected").data("kendoListBox") != undefined && $("#NotSelected").data("kendoListBox") != undefined) {
            document.getElementById("SelectedPagersCount").innerHTML = $("#Selected").data("kendoListBox").dataSource.data().length.toString();
            document.getElementById("NotSelectedPagersCount").innerHTML = $("#NotSelected").data("kendoListBox").dataSource.data().length.toString();
        }
    });
}
